// Who gets the inspector workspace — the module's own vocabulary, in one place.
//
// A leaf on purpose: no JSX and no imports, so InspectionRoutes.jsx can use it
// without an import cycle back through index.jsx. Everything outside the module
// should reach these through the barrel (src/inspection/index.jsx).
//
// Both tests are gated on the workspace setting first, so with the feature off
// an Inspector-group account behaves exactly like any other office account.

/** Does this user get the workspace at all (inspector, possibly also office)? */
export const usesInspectionWorkspace = (user) =>
  !!user?.inspection_workspace_enabled && !!user?.is_inspector;

/** Is this user confined to it, with no office access? */
export const isInspectionOnlyUser = (user) =>
  !!user?.inspection_workspace_enabled && !!user?.is_inspector_only;

/** Where an inspector-only account belongs after login. */
export const INSPECTION_HOME = "/inspection";
